export const ADD_PAYMENTS = 'ADD_PAYMENTS'
export const ADD_PAYMENT = 'ADD_PAYMENT'
export const ADD_PAYMENT_ENUMS = 'ADD_PAYMENT_ENUMS'
export const ADD_PAYMENT_STATUS_ENUMS = 'ADD_PAYMENT_STATUS_ENUMS'